<template>
    <div class="layer dialogLayer mask50" v-show="visible">

        <div class="dialog white_bg" :class="{roundBorder8 : roundBorder}" :style="'width:' + width + 'px'">

            <header class="dialogHeader generalPagePaddingH alignCenter font14r bold color101010 bottomBorderBBB"
                    style="line-height: 36px;">
                <div class="inner">
                    {{title}}
                </div>
            </header>

            <div class="dialogBody padding20">
                <div class="font14r color101010 lineHeight27r14f bold marginB10">
                    恭喜您成为我们师讯学员，在学习专题网课前请您认真阅读我们的服务协议，勾选一下协议点击确认即可进入学习！
                </div>
                <div class="alignC marginB12 font12r">
                    <input class="modernCheckbox alignBottom" type="checkbox" v-model="agreeStatus"/>
                    同意
                    <router-link class="red" :to="agreeServiceUrl">
                        《{{agreeServiceName}}》
                    </router-link>
                </div>
                <div class="alignC">
                    <button class="okButton font14r" @click="onOk" :disabled="!agreeStatus">确定</button>
                </div>
            </div>

<!--            <footer class="dialogFooter">-->

<!--            </footer>-->

        </div>
    </div>

</template>

<script>
import dialogPart from './part/dialogPart';

const config = {
    apiConfig : {

    }
};
export default {
    name: "confirmAgreementBeforeLearnDialog",
    extends : dialogPart,
    props : {
        width: {
            type : Number,
            default : 306
        },
        agreeServiceName :{
            type: String,
            default: '师讯平台用户协议'
        },
        agreeServiceUrl:{
            type: String,
            default: ''
        }
    },
    data() {
        return {
            title : '学习提示',
            apiConfig : config.apiConfig,
            agreeStatus: false
        }
    },
    methods : {
        onOk() {
            this.$emit('ok');
        }
    }
}
</script>
<style lang="scss" scoped>
.red {
    color: #BD3124;
}
.dialogLayer {
    display: grid;
    align-content: center;
    justify-content: center;
}
.dialog {
    min-height: 120px;
}
.okButton {
    width: 260px;
    background: #FFBB56;
    color: white;
    border-radius: 20px;
    line-height: 40px;
    padding: 0;
    border: none 0;
    &:disabled {
        opacity: .6;
    }
}
</style>
